import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import GenAi from './components/GenAi';
import ThankYou from './components/ThankYou';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/gen-ai-course-in-coimbatore" element={<GenAi />} />
        <Route path="/gen-ai-course-in-coimbatore/" element={<GenAi />} />
        <Route path="/gen-ai-course-in-coimbatore/thankyou" element={<ThankYou />} />
        <Route path="/gen-ai-course-in-coimbatore/thankyou/" element={<ThankYou />} />
        <Route path="/" element={<GenAi />} />
        <Route path="*" element={<GenAi />} />
      </Routes>
    </Router>
  );
}

export default App;
